import { AnalysisSetLinkTypesEnum } from "../../misc/api/AnalysisSetLinkTypes";
import { CoughAnalysisSet } from "webportalclient";


export default class CoughAnalysisSetUtilities {

    static GetSourcedFromLink(anSet: CoughAnalysisSet) {
        return anSet.linksSourcedFromThis.find(anSetLink => anSetLink.linkType === AnalysisSetLinkTypesEnum.SourcedFrom);
    }

    static GetCreatedFromLink(anSet: CoughAnalysisSet) {
        return anSet.linksSourcedFromThis.find(anSetLink => anSetLink.linkType === AnalysisSetLinkTypesEnum.CreatedFrom);
    }

    static IsCreatedFromAnother(anSet: CoughAnalysisSet) {
        return !!this.GetCreatedFromLink(anSet);
    }
}
